import { Link } from "react-router-dom";
import { Card, Col, Row } from "reactstrap";
import { Href } from "../../../../constants";
import { UserProfileIcons } from "../../../../data/applications/SocialApp";
import { SocialAppProp } from "../../../../types/Applications";
import { dynamicImage } from "../../../../utils";
import SocialTabs from "./SocialTabs";
import { Image } from "../../../../coreComponents/Image";

const ProfileHeader: React.FC<SocialAppProp> = ({ callback }) => {

  return (
    <Row>
      <Col sm="12" className="box-col-12">
        <Card className="hovercard text-center">
          <div className="cardheader socialheader" />
          <div className="user-image">
            <div className="avatar">
              <Image alt="user" src={dynamicImage(`user/1.jpg`)} />
            </div>
            <div className="icon-wrapper">
              <i className="icofont icofont-pencil-alt-5" />
            </div>
            <ul className="share-icons">
              {UserProfileIcons.map((item, index) => (
                <li key={index}>
                  <Link className={`social-icon bg-${item.color}`} to={Href}>
                    <i className={`fa fa-${item.icon}`} />
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="info market-tabs p-0">
            <SocialTabs callback={callback} />
          </div>
        </Card>
      </Col>
    </Row>
  );
};
export default ProfileHeader;